import { ApplicationState } from '@/store';
import React from 'react';
import Modal from 'react-bootstrap/esm/Modal';
import { useSelector } from 'react-redux';
import './style.scss';

interface Props {
    showModal: boolean;
    handleClose: () => void;
}

const LearningMapGoalHowToModal: React.FC<Props> = (props: Props) => {
    const { showModal, handleClose } = props;

    const { strings } = useSelector((state: ApplicationState) => ({ strings: state.locale.data }));

    return (
        <Modal className="goal-how-to-container" onHide={handleClose} show={showModal}>
            <Modal.Header closeButton>
                <h1>{strings.UNDERSTAND_YOUR_GOAL}</h1>
            </Modal.Header>
            <Modal.Body>
                <p className="description">{strings.GOAL_HOW_TO_SUMMARY}</p>

                <div className="topic">
                    <div className="point" />
                    <span dangerouslySetInnerHTML={{ __html: strings.GOAL_HOW_TO_ITEMS_DESCRIPTION }} />
                </div>

                <div className="topic">
                    <div className="point" />
                    <span dangerouslySetInnerHTML={{ __html: strings.GOAL_HOW_TO_LESSONS_DESCRIPTION }} />
                </div>

                <div className="topic">
                    <div className="point" />
                    <span dangerouslySetInnerHTML={{ __html: strings.GOAL_HOW_TO_EXTERNAL_LESSONS_DESCRIPTION }} />
                </div>

                <p className="goal-take-few-hours-text">{strings.GOAL_HOW_TO_CONCLUSION}</p>
            </Modal.Body>
        </Modal>
    );
};

export default LearningMapGoalHowToModal;
